import api from './api';

const prospectService = {
  getProspects: async () => {
    const response = await api.get('/prospects');
    return response.data;
  },
};

export default prospectService;
